<ion-content fullscreen="true">
  <div class="content-container">
    <div class="content">
      <ion-icon src="./assets/icon/alert.svg"></ion-icon>

      <div class="title-1">
        {{'PAGESPECIFIC_TEXT.FORM_LIST.EXIT_ALERT_LINE1' | translate}}
      </div>
      <div class="text-1">
        {{'PAGESPECIFIC_TEXT.FORM_LIST.EXIT_ALERT_LINE3' | translate}}
      </div>
    </div>

    <ion-footer mode="ios">
      <ion-button expand="full" class="action-btn" (click)="onDismiss(2)"
        >{{'PAGESPECIFIC_TEXT.FORM_LIST.EXIT_ALERT_SAVE_EXIT' |
        translate}}</ion-button
      >
      <ion-button
        expand="full"
        fill="outline"
        class="exit-btn"
        (click)="onDismiss(true)"
        >{{'PAGESPECIFIC_TEXT.FORM_LIST.EXIT_ALERT_EXIT_WITHOUT_SAVING' |
        translate}}</ion-button
      >
      <ion-button
        expand="full"
        class="cancel-btn"
        fill="clear"
        (click)="onDismiss(false)"
        >{{'PAGESPECIFIC_TEXT.FORM_LIST.EXIT_ALERT_BACK_BUTTON' |
        translate}}</ion-button
      >
    </ion-footer>
  </div>
</ion-content>
